import { isNil } from 'remeda';

import { CloseLineIcon, ErrorWarningIcon } from '@/icons';
import {
  type MinimalModalProps,
  Modal,
  type ModalProps,
} from '@/ui/Modal/modal.component';

export type ErrorModalProps = MinimalModalProps & {
  title?: string;
  description?: string;
  actionLabel?: string;
  onClose: ModalProps['onClose'];
  onAction?: () => void;
};

export const ErrorModal = ({
  title = 'There was an error...',
  description,
  actionLabel = 'Got it',
  onClose,
  onAction,
  ...rest
}: ErrorModalProps) => {
  const handleClick = () => {
    if (!isNil(onAction)) {
      onAction();
    } else {
      onClose(false);
    }
  };
  return (
    <Modal
      {...rest}
      onClose={onClose}
      open
      size="sm"
      containerClassName="relative flex max-w-[440px] flex-col items-center gap-6 rounded-xl p-6 shadow-xl-heavy"
    >
      <button
        type="button"
        aria-label="Close"
        onClick={() => onClose(false)}
        className="absolute right-3 top-3 rounded-md p-2 text-grey-main transition hover:bg-gray-100"
      >
        <CloseLineIcon className="h-5 w-5" />
      </button>
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-danger-surface">
        <ErrorWarningIcon className="h-6 w-6 text-danger" />
      </div>
      <div className="flex w-full flex-col items-center gap-4 text-center">
        <p className="text-xl font-bold text-heading">{title}</p>
        {description && (
          <p className="whitespace-pre-line text-sm text-muted">
            {description}
          </p>
        )}
      </div>
      <button
        type="button"
        onClick={handleClick}
        className="w-full rounded-lg border border-subtle bg-white px-3 py-2 text-base text-ink shadow-sm transition hover:bg-gray-50"
      >
        {actionLabel}
      </button>
    </Modal>
  );
};
